import {defineStore} from 'pinia';
import {ModuleDashboardParam} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import dashboardParamApi from '@/apis/dashboard/dashboardParamApi';
const dashboardParamStore = new BaseDictionaryStore(dashboardParamApi);
export const useDashboardParamStore = defineStore(ModuleDashboardParam, {
  state: () => ({
    ...dashboardParamStore.state,
    _config: {
      key: 'dashboard_param_id',
      table: 'dashboard_param',
      moduleName: 'tham số dashboard',
    },
    moduleName: 'dashboardParam',
  }),
  actions: {...dashboardParamStore.action},
  getters: {
    ...dashboardParamStore.getters,
  },
});
